import type { StaticImageData } from "next/image";
import { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";

// Import achieved icons
import beatEasyBotAchieved from "@rosette/assets/src/achievements/achieved/beat_easy_bot.png";
import beatMidBotAchieved from "@rosette/assets/src/achievements/achieved/beat_mid_bot.png";
import beatHardBotAchieved from "@rosette/assets/src/achievements/achieved/beat_hard_bot.png";
import beatPandaBotAchieved from "@rosette/assets/src/achievements/achieved/beat_panda_bot.png";
import cleanSweepAchieved from "@rosette/assets/src/achievements/achieved/clean_sweep.png";
import reviewUrAchieved from "@rosette/assets/src/achievements/achieved/review_ur.png";
import noMurcyAchieved from "@rosette/assets/src/achievements/achieved/no_murcy.png";
import fullDeployAchieved from "@rosette/assets/src/achievements/achieved/full_deploy.png";
import crowdedAchieved from "@rosette/assets/src/achievements/achieved/crowded.png";
import jackOfUrTradesAchieved from "@rosette/assets/src/achievements/achieved/jack_of_ur_trades.png";
import finkelOnlineAchieved from "@rosette/assets/src/achievements/achieved/finkel_online.png";
import blitzOnlineAchieved from "@rosette/assets/src/achievements/achieved/blitz_online.png";
import mastersOnlineAchieved from "@rosette/assets/src/achievements/achieved/masters_online.png";
import rating1000Achieved from "@rosette/assets/src/achievements/achieved/rating_1000.png";
import win10Achieved from "@rosette/assets/src/achievements/achieved/win_10.png";
import win100Achieved from "@rosette/assets/src/achievements/achieved/win_100.png";
import marksmanAchieved from "@rosette/assets/src/achievements/achieved/marksman.png";
import snipurAchieved from "@rosette/assets/src/achievements/achieved/snipur.png";
import justInTimeAchieved from "@rosette/assets/src/achievements/achieved/just_in_time.png";
import standUrGroundAchieved from "@rosette/assets/src/achievements/achieved/stand_ur_ground.png";

// Import locked icons
import beatXBotLocked from "@rosette/assets/src/achievements/locked/beat_x_bot.png";
import beatPandaBotLocked from "@rosette/assets/src/achievements/locked/beat_panda_bot.png";
import cleanSweepLocked from "@rosette/assets/src/achievements/locked/clean_sweep.png";
import reviewUrLocked from "@rosette/assets/src/achievements/locked/review_ur.png";
import noMurcyLocked from "@rosette/assets/src/achievements/locked/no_murcy.png";
import fullDeployLocked from "@rosette/assets/src/achievements/locked/full_deploy.png";
import crowdedLocked from "@rosette/assets/src/achievements/locked/crowded.png";
import jackOfUrTradesLocked from "@rosette/assets/src/achievements/locked/jack_of_ur_trades.png";
import finkelOnlineLocked from "@rosette/assets/src/achievements/locked/finkel_online.png";
import blitzOnlineLocked from "@rosette/assets/src/achievements/locked/blitz_online.png";
import mastersOnlineLocked from "@rosette/assets/src/achievements/locked/masters_online.png";
import rating1000Locked from "@rosette/assets/src/achievements/locked/rating_1000.png";
import win10Locked from "@rosette/assets/src/achievements/locked/win_10.png";
import win100Locked from "@rosette/assets/src/achievements/locked/win_100.png";
import marksmanLocked from "@rosette/assets/src/achievements/locked/marksman.png";
import snipurLocked from "@rosette/assets/src/achievements/locked/snipur.png";
import justInTimeLocked from "@rosette/assets/src/achievements/locked/just_in_time.png";
import standUrGroundLocked from "@rosette/assets/src/achievements/locked/stand_ur_ground.png";

export function getAchievementIcon(achievement: AchievementType): StaticImageData {
    if (achievement === AchievementType.BEAT_EASY_BOT)
        return beatEasyBotAchieved;
    if (achievement === AchievementType.BEAT_MEDIUM_BOT)
        return beatMidBotAchieved;
    if (achievement === AchievementType.BEAT_HARD_BOT)
        return beatHardBotAchieved;
    if (achievement === AchievementType.BEAT_PANDA_BOT)
        return beatPandaBotAchieved;
    if (achievement === AchievementType.CLEAN_SWEEP)
        return cleanSweepAchieved;
    if (achievement === AchievementType.REVIEW_UR)
        return reviewUrAchieved;
    if (achievement === AchievementType.NO_MURCY)
        return noMurcyAchieved;
    if (achievement === AchievementType.FULL_DEPLOY)
        return fullDeployAchieved;
    if (achievement === AchievementType.CROWDED)
        return crowdedAchieved;
    if (achievement === AchievementType.JACK_OF_UR_TRADES)
        return jackOfUrTradesAchieved;
    if (achievement === AchievementType.FINKEL_ONLINE)
        return finkelOnlineAchieved;
    if (achievement === AchievementType.BLITZ_ONLINE)
        return blitzOnlineAchieved;
    if (achievement === AchievementType.MASTERS_ONLINE)
        return mastersOnlineAchieved;
    if (achievement === AchievementType.RATING_1000)
        return rating1000Achieved;
    if (achievement === AchievementType.WIN_10)
        return win10Achieved;
    if (achievement === AchievementType.WIN_100)
        return win100Achieved;
    if (achievement === AchievementType.MARKSMAN)
        return marksmanAchieved;
    if (achievement === AchievementType.SNIPUR)
        return snipurAchieved;
    if (achievement === AchievementType.JUST_IN_TIME)
        return justInTimeAchieved;
    if (achievement === AchievementType.STAND_UR_GROUND)
        return standUrGroundAchieved;

    throw new Error("Unknown achievement type, " + achievement.getID());
}

export function getLockedAchievementIcon(achievement: AchievementType): StaticImageData {
    if (achievement === AchievementType.BEAT_EASY_BOT
        || achievement === AchievementType.BEAT_MEDIUM_BOT
        || achievement === AchievementType.BEAT_HARD_BOT)
        return beatXBotLocked;
    if (achievement === AchievementType.BEAT_PANDA_BOT)
        return beatPandaBotLocked;
    if (achievement === AchievementType.CLEAN_SWEEP)
        return cleanSweepLocked;
    if (achievement === AchievementType.REVIEW_UR)
        return reviewUrLocked;
    if (achievement === AchievementType.NO_MURCY)
        return noMurcyLocked;
    if (achievement === AchievementType.FULL_DEPLOY)
        return fullDeployLocked;
    if (achievement === AchievementType.CROWDED)
        return crowdedLocked;
    if (achievement === AchievementType.JACK_OF_UR_TRADES)
        return jackOfUrTradesLocked;
    if (achievement === AchievementType.FINKEL_ONLINE)
        return finkelOnlineLocked;
    if (achievement === AchievementType.BLITZ_ONLINE)
        return blitzOnlineLocked;
    if (achievement === AchievementType.MASTERS_ONLINE)
        return mastersOnlineLocked;
    if (achievement === AchievementType.RATING_1000)
        return rating1000Locked;
    if (achievement === AchievementType.WIN_10)
        return win10Locked;
    if (achievement === AchievementType.WIN_100)
        return win100Locked;
    if (achievement === AchievementType.MARKSMAN)
        return marksmanLocked;
    if (achievement === AchievementType.SNIPUR)
        return snipurLocked;
    if (achievement === AchievementType.JUST_IN_TIME)
        return justInTimeLocked;
    if (achievement === AchievementType.STAND_UR_GROUND)
        return standUrGroundLocked;

    throw new Error("Unknown achievement type, " + achievement.getID());
}
